import store from "@/services/store";
function list_names(list,id)
{
	if(list!==null && list!=='')
	{
			if( store.state.crudStore.lists[list].filter( list => { 
					return ( list.id.toString()=== id.toString() && id!='' ) || ( list.name.toString()=== id.toString() && id!='' ) } ))
			{
					return store.state.crudStore.lists[list].filter( list => {return list.id.toString()=== id.toString() || list.name.toString()=== id.toString() })[0].name 
			}

	}
	return ''  
}
function preciosServicios(value)
{
	let valor=0	
	for (let i = 0; i < value[0].length; i++) {
		switch(value[1])
		{
			case 1: 
				valor= valor+value[0][i].valoringreso
			break
			case 2: 
				valor= valor+value[0][i].valor
			break
			case 3: 
				valor= valor+value[0][i].valorretiro
			break
			case 4: 
				valor= valor+value[0][i].valor
			break
		}
	}
	
	return valor
}
export default {
	data(){
		return {
			tableAlertClass: function (items){ if(items.servicios_nuevos.length>0){return true} return false },
			tableAlertText: function (items){ if(items.servicios_nuevos.length>0){let name = 'El afiliado tiene los servicios de ';for (let i = 0; i < items.servicios_nuevos.length; i++) {name += items.servicios_nuevos[i].name+', ';} return name+' pendientes del radicado de afiliación.' } return null },

			tableGBoptions: { 
				options: {editar: 'Editar Aporte del Afiliado'},
			},

			tableGBSearch: ['datos_afiliado/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Nombres', btn: 'Guardar', msjBtn: 'Registrar seleccionados', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Documento' },
					tbody: { td: ['list_documento/name','datos_afiliado/documento'],}
				},
				{
					thead: { th: 'Servicios', },
					tbody: { td: ['servicios_activos'], ftn: function (value){ let name='';for(let i=0;i<value.length;i++){ if(value[i].name!='Administración'){name=name+' '+value[i].name; if(value[i].name_list!==null && value[i].name_list!==''){ name=name+' '+list_names(value[i].name_list,value[i].id_list)+' '}}} return name}}
				},
				{
					thead: { th: 'Novedad', },
					tbody: { td: ['list_novedad/name'],}
				},
				{
					thead: { th: 'Dias', },
					tbody: { td: ['info_afiliacion/dias'],}
				},
				{
					thead: { th: 'Valor', },
					tbody: { td: ['servicios_activos','info_afiliacion/id_list_novedad'], ftn: function (value){ return preciosServicios(value)}}
				},
			],			
		
		}
	},
}